/* eslint-disable consistent-return */
import { addSquadMembers } from '../../actions/game/squad.actions'

const rosterMiddleware = ({ dispatch, getState }) => next => (action) => {
    const { checkRoster } = action.meta || {}

    next(action)
    if (!checkRoster) {
        return
    }
    if (checkRoster === 'initialiseSquad') {
        dispatch(addSquadMembers([...Object.keys(getState().roster)]))
    }
}

export default rosterMiddleware
